import styled from 'astroturf/react'

import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'

import NotetakerIcon from './notetaker_icon.svg'
import _IconWrapper from "notetaker_illustration-IconWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/notetaker_illustration.js?styleId=IconWrapper";


const IconWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
})

export const NotetakerIllustration = () => {
  const { isEmbedded, unbranded, currentUser } = useConfirmationPageData()

  if (isEmbedded || unbranded || currentUser) return null

  return (
    <IconWrapper>
      <img src={NotetakerIcon} alt="AI Notetaker" width={64} height={64} />
    </IconWrapper>
  )
}
